import React, { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "@/redux/api";
import { useAuthEditable } from "@/hooks/use-auth";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ServiceRequestDetail from "@/containers/service-request/ServiceRequestDetail";

export default function FacilityServiceRequestDetailPage() {
  const { id } = useParams();
  const location = useLocation();
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const canAddNote = useAuthEditable("serviceRequest");
  const baseListPath = buildFacilityPath("service-request", facilityContext) || "/switch-view";
  const listPath = `${baseListPath}${location.search || ""}`;
  const loadRequest = useCallback(
    (requestId) => api.getFacilityServiceRequest(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addFacilityServiceRequestNote(requestId, content),
    []
  );

  return (
    <ServiceRequestDetail
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote={canAddNote}
    />
  );
}
